import React from 'react'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Text } from '@leverege/ui-elements'

import { Button, DropdownButton, MenuItem } from 'react-bootstrap'
import { ApiProvider } from '@leverege/api-redux'
import { BlueprintActions, ProjectActions, BreadcrumbActions, ScenarioActions, BlueprintUpdater } from '~/actions'

import { List, Screen, YesNoDialog, Flex } from '~/views'

import NoBlueprintsView from './NoBlueprintsView.jsx'
import BlueprintItem from './BlueprintItem.jsx'

import { TransferToProjectDialog } from '~/editors/project'

import Mermaid from './Mermaid'
import ToGraph from './ToGraph.js'
import style from './blueprintsScreen.css'
import FlowLegend from './FlowLegend.jsx'

let N = 0
const ROT = { 
  TD : 'LR', 
  TB : 'LR', 
  LR : 'BT', 
  BT : 'RL', 
  RL : 'TD' 
}

class BlueprintsScreen extends React.Component {

  static propTypes = {
    project : PropTypes.object
  }

  static contextType = ApiProvider.Context

  constructor( props ) {
    super( props )
    const url = new URL( window.location )
    const mode = url.searchParams.get( 'mode' ) || 'list'
    const graphType = url.searchParams.get( 'graphType' ) || 'groupFlow'
    const graphDir = url.searchParams.get( 'graphDir' ) || 'TD'

    this.state = { 
      selectId : null, 
      showRemoveDialog : false, 
      removeBlueprint : null, 
      showAddDialog : false,
      blueprints : null,
      graphDir,
      mode,
      graphType
    }
    this.n = ( N++ )
  }

  componentDidMount() {
    const { match, history, dispatch } = this.props
    dispatch( ProjectActions.getProject( match.params.projectId ) )
    dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Blueprints' } ] ) )
    
    this.context.project( match.params.projectId ).blueprints().list( {
      perPage : 1000, children : 'attribute', attribute : { perPage : 10000 } 
    } )
      .then( ( r ) => { this.setState( { blueprints : r } ) } )
    window.blueprintNodeClick = ( id ) => {
      history.push( `/project/${match.params.projectId}/blueprint/${id.substring( 1 )}/attributes` )

    }

  }

  componentWillUnmount() {
    window.blueprintNodeClick = null
  }

  static getDerivedStateFromProps( props, state ) {
    const { graphDir, mode, graphType } = state
    const url = new URL( window.location )
    const nMode = url.searchParams.get( 'mode' ) || 'list'
    const nGraphType = url.searchParams.get( 'graphType' ) || 'groupFlow'
    const nGraphDir = url.searchParams.get( 'graphDir' ) || 'TD'

    if ( nMode !== mode || nGraphDir !== graphDir || nGraphType !== graphType ) {
      return { graphDir : nGraphDir, graphType : nGraphType, mode : nMode }
    }
    return null
  }

  onCreateBlueprint = () => {
    const { history, dispatch, project } = this.props

    dispatch( ProjectActions.addBlueprint( 
      project, 
      { name : 'My Blueprint', desc : '', purpose : 'device' }, 
      history ) ).then( ( bp ) => {
      history.push( `/project/${bp.projectId}/blueprint/${bp.id}` )
    } )

    this.setState( { showAddDialog : false } )
  }

  onCreateBlueprintForOrg = () => {
    const { history, dispatch, project } = this.props
    dispatch( ProjectActions.addBlueprint( 
      project, 
      { name : 'My Grouping Blueprint', desc : '', purpose : 'organization' }, 
      history ) ).then( ( bp ) => {
      history.push( `/project/${bp.projectId}/blueprint/${bp.id}` )

    } )
    this.setState( { showAddDialog : false } )
  }

  onCreateBlueprintJSON = () => {
    // Link to a JSON uploader page 
    const { history, dispatch, match, project } = this.props
    dispatch( ProjectActions.addBlueprint( 
      project, 
      { name : 'My Blueprint from JSON', desc : '' } ) )
    history.push( `/project/${match.params.projectId}/jsonuploader/` )
  }

  onBlueprintOpen = ( blueprint ) => {
    const { history, match } = this.props
    history.push( `/project/${match.params.projectId}/blueprint/${blueprint.id}/attributes` )
  }

  onEvent = ( event, blueprint ) => {
    const { dispatch, history, match } = this.props
    
    if ( event == 'select' ) {
      this.onBlueprintOpen( blueprint )
    } else if ( event == BlueprintItem.EDIT_ATTRIBUTES_EVENT ) {
    } else if ( event == BlueprintItem.SIMULATE_EVENT ) {
      dispatch( BlueprintActions.simulateBlueprint( blueprint ) )
    } else if ( event == BlueprintItem.CREATE_SCENARIO ) {
      dispatch( ScenarioActions.createScenario( { projectId : blueprint.projectId, blueprintId : blueprint.id } ) )
    } else if ( event == BlueprintItem.REMOVE_EVENT ) {
      this.setState( { showRemoveDialog : true, removeBlueprint : blueprint } )

    } else if ( event == BlueprintItem.EXPORT_RAW ) {
      history.push( `/project/${match.params.projectId}/blueprint/${blueprint.id}/raw` )
    } else if ( event == BlueprintItem.EXPORT_SPEC ) {
      history.push( `/project/${match.params.projectId}/blueprint/${blueprint.id}/spec` )
    } else if ( event == BlueprintItem.TRANSFER_EVENT ) {
      this.setState( { showTransfer : true, transferItem : blueprint } )
    } else {
      console.warn( 'Received Unknown Event', event, 'on Blueprint', blueprint ) // eslint-disable-line no-console
    }
  }

  onPromptRemoveYes = () => {
    const { dispatch } = this.props
    const { removeBlueprint } = this.state
    dispatch( ProjectActions.removeBlueprint( removeBlueprint ) )
    this.setState( { showRemoveDialog : false, removeBlueprint : null } )
  }

  onPromptRemoveNo = () => {
    this.setState( { showRemoveDialog : false, removeBlueprint : null } )
  }

  onBlueprintChange = ( event ) => {
    const { dispatch } = this.props 

    BlueprintUpdater( dispatch, event.target )
      .set( event.path, event.value )
      .done()
  }

  onTransfer = ( blueprint, toProject ) => {
    this.onBlueprintChange( { target : blueprint, path : 'projectId', value : toProject.id } )
    this.setState( { showTransfer : false, transferItem : null } )
  }

  onImport = () => {
    const { history, match } = this.props
    history.push( `/project/${match.params.projectId}/importBlueprint` )
  }

  onList = ( ) => {
    const { history, match } = this.props
    history.push( `/project/${match.params.projectId}/blueprint` )
    this.setState( { mode : 'list' } )
  }

  onGraph = ( ) => {
    const { history, match } = this.props
    const { graphType, graphDir } = this.state
    history.push( `/project/${match.params.projectId}/blueprint?mode=graph&graphType=${graphType}&graphDir=${graphDir}` )
    this.setState( { mode : 'graph' } )
  }

  onGraphRotate = ( ) => {
    const { history, match } = this.props
    const { graphDir : cDir, graphType } = this.state
    const graphDir = ROT[cDir] || 'TD'
    this.setState( { graphDir } ) 
    history.push( `/project/${match.params.projectId}/blueprint?mode=graph&graphType=${graphType}&graphDir=${graphDir}` )
  }

  onGraphType = ( obj ) => {
    const { history, match } = this.props
    const { graphDir } = this.state
    const { graphType } = obj    
    this.setState( { graphType } ) 
    history.push( `/project/${match.params.projectId}/blueprint?mode=graph&graphType=${graphType}&graphDir=${graphDir}` )

  }

  createVisual() {
    const { blueprints, graphDir, graphType } = this.state
    if ( blueprints == null ) {
      return <Text>Loading...</Text>
    }
    if ( blueprints.items.length === 0 ) {
      return <Text>No Blueprints</Text>
    }
    
    let chart
    if ( graphType === 'er' ) {
      chart = ToGraph.toEr( blueprints.items, graphDir )
    } else if ( graphType === 'flow' ) {
      chart = ToGraph.toFlow( blueprints.items, graphDir )
    } else if ( graphType === 'class' ) {
      chart = ToGraph.toClass( blueprints.items, graphDir )
    } else { // groupFlow
      chart = ToGraph.toGroupFlow( blueprints.items, graphDir )
    }
    return (
      <TransformWrapper 
        key={`${graphDir}-${graphType}`} 
        centerZoomedOut
        minScale={0.1}
        wrapperClass={style.zoomWrapper}>
        {( { zoomIn, zoomOut, resetTransform, ...rest } ) => (
          <React.Fragment>
            { ( graphType !== 'er' && graphType !== 'class' ) && <FlowLegend/> }
            <div className={style.tools}>
              <button onClick={() => zoomIn()}><i className="fa fa-plus fa-fw"/></button>
              <button onClick={() => zoomOut()}><i className="fa fa-minus fa-fw"/></button>
              <button onClick={() => resetTransform()}><i className="fa fa-arrows fa-fw"/></button>
              <button onClick={this.onGraphRotate}><i className="fa fa-rotate-left fa-fw"/></button>
              <DropdownButton noCaret pullRight bsStyle="link" id="more" title={<i className="fa fa-gears fa-fw" />}>
                <MenuItem bsStyle="link" bsSize="large" onClick={() => this.onGraphType( { graphType : 'groupFlow' } )}> 
                  Group Relationship Diagram
                </MenuItem>
                <MenuItem bsStyle="link" bsSize="large" onClick={() => this.onGraphType( { graphType : 'flow' } )}> 
                  Relationship Diagram
                </MenuItem>
                <MenuItem bsStyle="link" bsSize="large" onClick={() => this.onGraphType( { graphType : 'class' } )}> 
                  Class Relationship Diagram
                </MenuItem>
                {/* <MenuItem bsStyle="link" bsSize="large" onClick={()=>this.onGraphType( { graphType : 'er' } )}> 
                  Entity Relationship Diagram
                </MenuItem> */}
              </DropdownButton>
            </div>
            <TransformComponent>
              <Mermaid key={`${graphDir}-${graphType}`} chart={chart}/>
            </TransformComponent>
          </React.Fragment>
        )}
      </TransformWrapper>
    )
  }

  render() {
    const { blueprints, mode, showRemoveDialog, removeBlueprint, showAddDialog, transferItem, showTransfer, selectId } = this.state
    const { projects } = this.props

    if ( blueprints == null ) {
      return <div>Loading Blueprints</div>
    } 

    const isSelected = item => item?.id === selectId

    const list = mode === 'graph' ? this.createVisual() : (
      <List className={style.list}
        onEvent={this.onEvent}
        isSelected={isSelected} 
        noItemsView={<NoBlueprintsView />}
        items={blueprints?.items}
        itemView={BlueprintItem} />
    )

    return (
      <Screen>
        <Screen.Header className={style.header}>
          <Text variant="screenTitle">Blueprints</Text>
          <span style={{ display : 'flex', flexWrap : 'none' }}>
            <Button bsStyle="link"
              onClick={this.onList}> 
              <i className="fa fa-fw fa-list fa-lg" />
            </Button>
            <Button bsStyle="link"
              onClick={this.onGraph}> 
              <i className="fa fa-fw fa-sitemap fa-lg" />
            </Button>
            <div style={{ width : '32px' }} />
            <Button bsStyle="primary"
              className="add-button" 
              onClick={() => this.setState( { showAddDialog : true } )}> 
              <i className="fa fa-fw fa-circle-plus fa-lg" />
              {' '}
              New Blueprint
            </Button>
            <DropdownButton noCaret pullRight bsStyle="link" id="more" title={<i className="fa fa-ellipsis-vertical fa-lg fa-fw" />}>
              <MenuItem bsStyle="link"
                bsSize="large" 
                onClick={this.onImport}> 
                <i className="fa fa-upload fa-fw" />
                {' '}
                Import
              </MenuItem>
            </DropdownButton>
          </span>
        </Screen.Header>
        <Screen.Content>
          {list}
        </Screen.Content>
        <YesNoDialog show={showRemoveDialog} 
          title={`Remove ${removeBlueprint && removeBlueprint.name}?`}
          message={<div>Are you sure you want to delete the blueprint?</div>}
          onYes={this.onPromptRemoveYes}
          onNo={this.onPromptRemoveNo} />

        <YesNoDialog
          show={showAddDialog}
          bsSize={null}
          variant="dialogLarge"
          title="Is this a device Blueprint?"
          message={(
            <div>
              <Flex align="start">
                <Flex.Layout grow={1}>
                  <div className={style.addTypeButton} onClick={this.onCreateBlueprint}>
                    <i className="fa fa-microchip fa-fw" />
                    <h3>Hardware</h3>
                    <p>
                      The blueprint will be used for a device.
                      Examples might include a temperature gauge, a GPS tracking device, or a complex device
                      that reports multiple types of information.
                    </p>
                  </div>
                </Flex.Layout>
                <Flex.Layout grow={1}>
                  <div className={style.addTypeButton} onClick={this.onCreateBlueprintForOrg}>
                    <i className="fa fa-object-group fa-fw" />
                    <h3>Organization</h3>
                    <p>
                      The blueprint will be used for organization and grouping of data. 
                      Examples might include a Corporation, or a Vehicle that is equiped
                      with various devices.
                    </p>
                  </div>
                </Flex.Layout>
              </Flex>
            </div>
          )}
          yes="Cancel"
          onNo={() => { this.setState( { showAddDialog : false } ) }} />

        <TransferToProjectDialog objType="Blueprint"
          object={transferItem}
          projects={projects}
          show={showTransfer}
          onCancel={() => { this.setState( { showTransfer : false, transferItem : null } ) }}
          onTransfer={this.onTransfer} />
      </Screen>
    )
  }

} 

export default connect(
  state => ( {
    project : state.project,
    projects : state.projects
  } )
)( BlueprintsScreen )
